export type ConfigResponseType = {
    placementId: string;
    group: string;
}

export enum BannerType {
    // Баннеры в промо блоке после 2-го сниппета
    NB_SERP_PROMO_1_DESKTOP,
    NB_SERP_PROMO_1_TOUCH,

    // Баннеры в промо блоке после 5-го сниппета
    NB_SERP_PROMO_2_DESKTOP,
    NB_SERP_PROMO_2_TOUCH,

    // Баннеры в карточке справа (только Desktop)
    NB_CARD_RIGHT_DESKTOP,

    // Баннеры в карточке снизу
    NB_CARD_BOTTOM_DESKTOP,
    NB_CARD_BOTTOM_TOUCH
}

/*
    Баннеры для Самолета:
    - https://jira.m2.ru/browse/NB-6091
*/

export const getBannerConfig = (type: BannerType): ConfigResponseType => {
    switch (type) {
        case BannerType.NB_SERP_PROMO_1_DESKTOP:
            return {
                placementId: 'nb-search-promo',
                group: 'serp'
            };

        case BannerType.NB_SERP_PROMO_1_TOUCH:
            return {
                placementId: 'nb-search-promo',
                group: 'serp'
            };

        case BannerType.NB_SERP_PROMO_2_DESKTOP:
            return {
                placementId: 'nb-search-vipsnippet',
                group: 'serp'
            };

        case BannerType.NB_SERP_PROMO_2_TOUCH:
            return {
                placementId: 'nb-search-vipsnippet',
                group: 'serp'
            };

        case BannerType.NB_CARD_RIGHT_DESKTOP:
            return {
                placementId: 'nb-card-right',
                group: 'card'
            };

        case BannerType.NB_CARD_BOTTOM_DESKTOP:
            return {
                placementId: 'nb-page-bottom',
                group: 'card'
            };

        case BannerType.NB_CARD_BOTTOM_TOUCH:
            return {
                placementId: 'nb-page-bottom',
                group: 'card'
            };

        default:
            return {
                placementId: '',
                group: '',
            };
    }
};
